import { jsx as _jsx } from "react/jsx-runtime";
import Stick from '../../../es';
import Regression from './Regression';
function ScrollPosition() {
    return (_jsx(Regression, { fixed: true, allBrowsers: true, version: "3.0.3", title: "Node should scroll with anchor node", description: "Scroll to the side. The node should move with the anchor node.", children: _jsx("div", { style: { overflow: 'auto', height: 200, border: '1px solid black' }, children: _jsx("div", { style: {
                    width: 5000,
                    height: 5000,
                    marginLeft: 20,
                    marginTop: 20,
                    display: 'flex',
                    alignItems: 'flex-start',
                }, children: _jsx(Stick, { node: _jsx(Node, { children: "This node should always stick with its anchor" }), children: _jsx(Anchor, { children: "Scroll to the right. The node should move with this element." }) }) }) }) }));
}
const Anchor = ({ children }) => (_jsx("div", { style: {
        padding: 10,
        backgroundColor: 'rgb(24, 170, 177)',
        color: 'white',
    }, children: children }));
const Node = ({ children }) => (_jsx("div", { style: {
        backgroundColor: '#ae0d5c',
        color: 'white',
        padding: 10,
    }, children: children }));
export default ScrollPosition;
